module.exports = __webpack_public_path__ + "img/tw.6872d85f.png";